import React from "react";

const VideoContainer: React.FC<{
  youtubeId: string | undefined;
  height?: string;
}> = ({ youtubeId }) => {
  if (youtubeId === undefined) return null;
  console.log(`https://youtube.com/embed/${youtubeId}?autoplay=0`);
  return (
    <div style={{ maxWidth: 1600 / 1.5, maxHeight: 900 / 1.5, width: "100%", flex: 1 }}>
      <div
        style={{
          position: "relative",
          overflow: "hidden",
          width: "100%",
          paddingTop: "56.25%",
        }}
      >
        <iframe
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            width: "100%",
            height: "100%",
          }}
          title="Youtube player"
          allowFullScreen
          frameBorder="0"
          src={`https://youtube.com/embed/${youtubeId}?autoplay=0`}
        />
      </div>
    </div>
  );
};

export default VideoContainer;
